import type { SessionStepModule } from '../types';
import { UtilityBillDetail } from './UtilityBillDetail';
import { UtilityBillStepRunner } from './UtilityBillStepRunner';
import { isUtilityStep } from './utility.utils';

// Combined Utility Bill Verification step module (Electricity / PNG / LPG).
export const utilityStepModule: SessionStepModule = {
  key: 'utility',
  matches: isUtilityStep,
  Runner: UtilityBillStepRunner,
  Detail: UtilityBillDetail,
};
